import React, {useEffect, useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography} from "@mui/material";
import css_buttons from "../../../../components/Common/css/CCButton.module.scss";
import EnterpriseComponent from "../../../ec/EnterpriseComponent";
import EventBus from "../../../../util/EventBus";
import CCButton from "../../../../components/Common/CCButton";
import spinner from "../../../../assets/Spinner-1s-200px.svg";
import {prepareBuffer} from "../../../../util/Buffer";
import {makeEnterpriseComponent, updateObject} from "../../../../util/utility";


export default function SolidworksConfigurationApplet(props: any) {
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [partDocumentTypeEnterpriseComponent] = useState(() => makeEnterpriseComponent("DocumentType"));
    const [partDocumentTypeFormEnterpriseComponent] = useState(() =>makeEnterpriseComponent("DocumentTypeForm"));
    const [assemblyDocumentTypeEnterpriseComponent] = useState(() =>makeEnterpriseComponent("DocumentType"));
    const [assemblyDocumentTypeFormEnterpriseComponent] = useState(() =>makeEnterpriseComponent("DocumentTypeForm"));
    const [arDocumentTypeEnterpriseComponent] = useState(() =>makeEnterpriseComponent("DocumentType"));
    const [arDocumentTypeFormEnterpriseComponent] = useState(() =>makeEnterpriseComponent("DocumentTypeForm"));

    const [partDocumentTypeFetchBackgroundOperation, setPartDocumentTypeFetchBackgroundOperation] = useState(false);
    const [partDocumentTypeFormFetchBackgroundOperation, setPartDocumentTypeFormFetchBackgroundOperation] = useState(false);
    const [assemblyDocumentTypeFetchBackgroundOperation, setAssemblyDocumentTypeFetchBackgroundOperation] = useState(false);
    const [assemblyDocumentTypeFormFetchBackgroundOperation, setAssemblyDocumentTypeFormFetchBackgroundOperation] = useState(false);
    const [arDocumentTypeFetchBackgroundOperation, setARDocumentTypeFetchBackgroundOperation] = useState(false);
    const [arDocumentTypeFormFetchBackgroundOperation, setARDocumentTypeFormFetchBackgroundOperation] = useState(false);

    const [partDocumentTypeBuffer, setPartDocumentTypeBuffer] = React.useState<Map<string, any>[]>([]);
    const [assemblyDocumentTypeBuffer, setAssemblyDocumentTypeBuffer] = React.useState<Map<string, any>[]>([]);
    const [arDocumentTypeBuffer, setARDocumentTypeBuffer] = React.useState<Map<string, any>[]>([]);

    const [partFormBuffer, setPartFormBuffer] = React.useState<Map<string, any>[]>([]);
    const [assemblyFormBuffer, setAssemblyFormBuffer] = React.useState<Map<string, any>[]>([]);
    const [arFormBuffer, setARFormBuffer] = React.useState<Map<string, any>[]>([]);

    const [controls, setControls] = useState<any>({
        "PartDocumentTypeUSID": {"value": ""},
        "PartFormDocumentRevisionUSID": {"value": ""},
        "AssemblyDocumentTypeUSID": {"value": ""},
        "AssemblyFormDocumentRevisionUSID": {"value": ""},
        "ARDocumentTypeUSID": {"value": ""},
        "ARFormDocumentRevisionUSID": {"value": ""},
    });

    function enterpriseComponentUpdateStartedListener(_: EnterpriseComponent) {
        setBackgroundOperation(true)
    }

    function enterpriseComponentUpdateCompletedListener(_: EnterpriseComponent) {
        EventBus.components.emit("solidworks-configuration-form-applet-save");
    }

    function isFormValid() {
        if (controls["PartDocumentTypeUSID"].value.length === 0) return false;
        if (controls["PartFormDocumentRevisionUSID"].value.length === 0) return false;
        if (controls["AssemblyDocumentTypeUSID"].value.length === 0) return false;
        if (controls["AssemblyFormDocumentRevisionUSID"].value.length === 0) return false;
        if (controls["ARDocumentTypeUSID"].value.length === 0) return false;

        return controls["ARFormDocumentRevisionUSID"].value.length !== 0;
    }

    useEffect(() => {
        const enterpriseComponentInsertStartedListener = (_: EnterpriseComponent)=> {
            setBackgroundOperation(true)
        }

        const enterpriseComponentInsertCompletedListener = (_: EnterpriseComponent)=> {
            EventBus.components.emit("solidworks-configuration-form-applet-save");
        }

        const enterpriseComponentLoadCompletedListener = (ec: EnterpriseComponent) => {
            let b:Map<string, any>[] = prepareBuffer(ec)

            if (ec.serialNumber === partDocumentTypeEnterpriseComponent.serialNumber) {
                setPartDocumentTypeBuffer(b);
                setPartDocumentTypeFetchBackgroundOperation(false)
            }
            if (ec.serialNumber === partDocumentTypeFormEnterpriseComponent.serialNumber) {
                setPartFormBuffer(b);
                setPartDocumentTypeFormFetchBackgroundOperation(false)
            }
            if (ec.serialNumber === assemblyDocumentTypeEnterpriseComponent.serialNumber) {
                setAssemblyDocumentTypeBuffer(b);
                setAssemblyDocumentTypeFetchBackgroundOperation(false)
            }
            if (ec.serialNumber === assemblyDocumentTypeFormEnterpriseComponent.serialNumber) {
                setAssemblyFormBuffer(b);
                setAssemblyDocumentTypeFormFetchBackgroundOperation(false)
            }
            if (ec.serialNumber === arDocumentTypeEnterpriseComponent.serialNumber) {
                setARDocumentTypeBuffer(b);
                setARDocumentTypeFetchBackgroundOperation(false)
            }
            if (ec.serialNumber === arDocumentTypeFormEnterpriseComponent.serialNumber) {
                setARFormBuffer(b);
                setARDocumentTypeFormFetchBackgroundOperation(false)
            }
        }

        const enterpriseComponentLoadStartedListener = (ec: EnterpriseComponent)=> {
            if (ec.serialNumber === partDocumentTypeEnterpriseComponent.serialNumber) {
                setPartDocumentTypeFetchBackgroundOperation(true)
            }
            if (ec.serialNumber === partDocumentTypeFormEnterpriseComponent.serialNumber) {
                setPartDocumentTypeFormFetchBackgroundOperation(true)
            }
            if (ec.serialNumber === assemblyDocumentTypeEnterpriseComponent.serialNumber) {
                setAssemblyDocumentTypeFetchBackgroundOperation(true)
            }
            if (ec.serialNumber === assemblyDocumentTypeFormEnterpriseComponent.serialNumber) {
                setAssemblyDocumentTypeFormFetchBackgroundOperation(true)
            }
            if (ec.serialNumber === arDocumentTypeEnterpriseComponent.serialNumber) {
                setARDocumentTypeFetchBackgroundOperation(true)
            }
            if (ec.serialNumber === arDocumentTypeFormEnterpriseComponent.serialNumber) {
                setARDocumentTypeFormFetchBackgroundOperation(true)
            }
        }

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;

        solidworksConfigurationEnterpriseComponent.addInsertStartedListener(enterpriseComponentInsertStartedListener);
        solidworksConfigurationEnterpriseComponent.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);
        solidworksConfigurationEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStartedListener);
        solidworksConfigurationEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);

        partDocumentTypeEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        partDocumentTypeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        partDocumentTypeFormEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        partDocumentTypeFormEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        assemblyDocumentTypeEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        assemblyDocumentTypeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        assemblyDocumentTypeFormEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        assemblyDocumentTypeFormEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        arDocumentTypeEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        arDocumentTypeEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        arDocumentTypeFormEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        arDocumentTypeFormEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        partDocumentTypeEnterpriseComponent.newQuery();
        partDocumentTypeEnterpriseComponent.setAttributeValue("Group", "PART");
        partDocumentTypeEnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
        partDocumentTypeEnterpriseComponent.executeQuery(1, 100);

        assemblyDocumentTypeEnterpriseComponent.newQuery();
        assemblyDocumentTypeEnterpriseComponent.setAttributeValue("Group", "PART");
        assemblyDocumentTypeEnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
        assemblyDocumentTypeEnterpriseComponent.executeQuery(1, 100);

        arDocumentTypeEnterpriseComponent.newQuery();
        arDocumentTypeEnterpriseComponent.setAttributeValue("Group", "CHANGE_REQUEST");
        arDocumentTypeEnterpriseComponent.setIDOCResponse("v1.DocumentType-001");
        arDocumentTypeEnterpriseComponent.executeQuery(1, 100);

        if (props.defaultAction === "New") {
            solidworksConfigurationEnterpriseComponent.newRecord();
        } else {
            partDocumentTypeFormEnterpriseComponent.newQuery();
            partDocumentTypeFormEnterpriseComponent.setAttributeValue("USID", solidworksConfigurationEnterpriseComponent.getAttributeValue("PartDocumentTypeUSID"));
            partDocumentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
            partDocumentTypeFormEnterpriseComponent.executeQuery(1, 50);

            assemblyDocumentTypeFormEnterpriseComponent.newQuery();
            assemblyDocumentTypeFormEnterpriseComponent.setAttributeValue("USID", solidworksConfigurationEnterpriseComponent.getAttributeValue("AssemblyDocumentTypeUSID"));
            assemblyDocumentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
            assemblyDocumentTypeFormEnterpriseComponent.executeQuery(1, 50);

            arDocumentTypeFormEnterpriseComponent.newQuery();
            arDocumentTypeFormEnterpriseComponent.setAttributeValue("USID", solidworksConfigurationEnterpriseComponent.getAttributeValue("ARDocumentTypeUSID"));
            arDocumentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
            arDocumentTypeFormEnterpriseComponent.executeQuery(1, 50);

            setControls({
                "PartDocumentTypeUSID": {"value": solidworksConfigurationEnterpriseComponent.getAttributeValue("PartDocumentTypeUSID")},
                "PartFormDocumentRevisionUSID": {"value": solidworksConfigurationEnterpriseComponent.getAttributeValue("PartFormDocumentRevisionUSID")},
                "AssemblyDocumentTypeUSID": {"value": solidworksConfigurationEnterpriseComponent.getAttributeValue("AssemblyDocumentTypeUSID")},
                "AssemblyFormDocumentRevisionUSID": {"value": solidworksConfigurationEnterpriseComponent.getAttributeValue("AssemblyFormDocumentRevisionUSID")},
                "ARDocumentTypeUSID": {"value": solidworksConfigurationEnterpriseComponent.getAttributeValue("ARDocumentTypeUSID")},
                "ARFormDocumentRevisionUSID": {"value": solidworksConfigurationEnterpriseComponent.getAttributeValue("ARFormDocumentRevisionUSID")}
            })
        }

        return () => {
            partDocumentTypeEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            partDocumentTypeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            partDocumentTypeFormEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            partDocumentTypeFormEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);

            assemblyDocumentTypeEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            assemblyDocumentTypeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            assemblyDocumentTypeFormEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            assemblyDocumentTypeFormEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);

            arDocumentTypeEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            arDocumentTypeEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            arDocumentTypeFormEnterpriseComponent.removeLoadStartedListener(enterpriseComponentLoadStartedListener);
            arDocumentTypeFormEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);

            solidworksConfigurationEnterpriseComponent.removeInsertStartedListener(enterpriseComponentInsertStartedListener);
            solidworksConfigurationEnterpriseComponent.removeInsertCompletedListener(enterpriseComponentInsertCompletedListener);
            solidworksConfigurationEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStartedListener);
            solidworksConfigurationEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompletedListener);
        }

    }, [props.defaultAction, props.enterpriseComponent, arDocumentTypeEnterpriseComponent, arDocumentTypeFormEnterpriseComponent, assemblyDocumentTypeEnterpriseComponent, assemblyDocumentTypeFormEnterpriseComponent, partDocumentTypeEnterpriseComponent, partDocumentTypeFormEnterpriseComponent]);

    function onCancelHandler() {
        EventBus.components.emit("solidworks-configuration-form-applet-cancel");
    }

    function saveHandler() {
        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent
        if (props.defaultAction === "New") {
            solidworksConfigurationEnterpriseComponent.executeInsert();
        }
        if (props.defaultAction === "Edit") {
            solidworksConfigurationEnterpriseComponent.executeUpdate();
        }
    }

    function partDocumentTypeChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["PartDocumentTypeUSID"], {
            value: event.target.value,
            touched: true,
            valid: true,
        });
        const updatedForm = updateObject(controls, {
            "PartDocumentTypeUSID": updatedFormElement,
        });

        setControls(updatedForm);

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;
        solidworksConfigurationEnterpriseComponent.setAttributeValue("PartDocumentTypeUSID", event.target.value)
    }

    function partFormChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["PartFormDocumentRevisionUSID"], {
            value: event.target.value,
            touched: true,
            valid: true,
        });
        const updatedForm = updateObject(controls, {
            "PartFormDocumentRevisionUSID": updatedFormElement,
        });

        setControls(updatedForm);

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;
        solidworksConfigurationEnterpriseComponent.setAttributeValue("PartFormDocumentRevisionUSID", event.target.value)
    }

    function assemblyDocumentTypeChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["AssemblyDocumentTypeUSID"], {
            value: event.target.value,
            touched: true,
            valid: true,
        });
        const updatedForm = updateObject(controls, {
            "AssemblyDocumentTypeUSID": updatedFormElement,
        });

        setControls(updatedForm);

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;
        solidworksConfigurationEnterpriseComponent.setAttributeValue("AssemblyDocumentTypeUSID", event.target.value)
    }

    function assemblyFormChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["AssemblyFormDocumentRevisionUSID"], {
            value: event.target.value,
            touched: true,
            valid: true,
        });
        const updatedForm = updateObject(controls, {
            "AssemblyFormDocumentRevisionUSID": updatedFormElement,
        });

        setControls(updatedForm);

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;
        solidworksConfigurationEnterpriseComponent.setAttributeValue("AssemblyFormDocumentRevisionUSID", event.target.value)
    }

    function arFormChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["ARFormDocumentRevisionUSID"], {
            value: event.target.value,
            touched: true,
            valid: true,
        });
        const updatedForm = updateObject(controls, {
            "ARFormDocumentRevisionUSID": updatedFormElement,
        });

        setControls(updatedForm);

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;
        solidworksConfigurationEnterpriseComponent.setAttributeValue("ARFormDocumentRevisionUSID", event.target.value)
    }

    function arDocumentTypeChangedHandler(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
        const updatedFormElement = updateObject(controls["ARDocumentTypeUSID"], {
            value: event.target.value,
            touched: true,
            valid: true,
        });
        const updatedForm = updateObject(controls, {
            "ARDocumentTypeUSID": updatedFormElement,
        });

        setControls(updatedForm);

        const solidworksConfigurationEnterpriseComponent: EnterpriseComponent = props.enterpriseComponent;
        solidworksConfigurationEnterpriseComponent.setAttributeValue("ARDocumentTypeUSID", event.target.value)
    }

    function updateView() {
        let buttonHandler;

        let firstButtonHandlerContent = (
            <CCButton
                key={1}
                className={css_buttons.redStandardButton}
                onClick={onCancelHandler}>
                Cancel
            </CCButton>
        );

        let secondButtonHandlerContent = (
            <CCButton
                key={2}
                disabled={!isFormValid()}
                className={css_buttons.blueStandardButton}
                animate={backgroundOperation}
                onClick={() => saveHandler()}>
                Save
            </CCButton>
        )

        buttonHandler = (
            <DialogActions style={{marginBottom: "10px", width: "96%"}}>
                {firstButtonHandlerContent}
                {secondButtonHandlerContent}
            </DialogActions>
        );

        return (
            <>
                <Dialog open={true} scroll="body">
                    <DialogTitle>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                            <Typography style={{fontSize: "20px", fontWeight: 500, color: "#000000"}}>Solidworks Configuration:</Typography>
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <div key="1" style={{display: "flex", flexDirection: "row", margin: "10px 20px 20px 0"}}>
                                {partDocumentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                                    <TextField
                                        select
                                        key="PartDocumentType"
                                        margin="dense"
                                        fullWidth={true}
                                        id="PartDocumentType"
                                        label="Part Document Type *"
                                        onChange={(event) => {
                                            partDocumentTypeChangedHandler(event);

                                            partDocumentTypeFormEnterpriseComponent.newQuery();
                                            partDocumentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                            partDocumentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                            partDocumentTypeFormEnterpriseComponent.executeQuery(1, 50);
                                        }}
                                        value={controls["PartDocumentTypeUSID"].value}
                                        variant="outlined"
                                        slotProps={{
                                            input: {},
                                            inputLabel: {shrink: true}
                                        }}>
                                        {partDocumentTypeBuffer.map((element: any) => (
                                            <MenuItem key={element.USID} value={element.get("USID")}>
                                                {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            </div>
                            <div key="2" style={{display: "flex", flexDirection: "row", margin: "10px 20px 20px 0"}}>
                                {controls["PartDocumentTypeUSID"].value !== "" ? (
                                    <>
                                        {partDocumentTypeFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                                            <TextField
                                                select
                                                key="Form"
                                                margin="dense"
                                                fullWidth={true}
                                                id="PartForm"
                                                label="Part Form *"
                                                onChange={(event) => {
                                                    partFormChangedHandler(event)
                                                }}
                                                value={controls["PartFormDocumentRevisionUSID"].value}
                                                variant="outlined"
                                                slotProps={{
                                                    input: {},
                                                    inputLabel: {shrink: true}
                                                }}>
                                                {partFormBuffer[0].get("ListOfFormTemplate").FormTemplate.map((element: any) => (
                                                    <MenuItem key={element.DocumentRevisionUSID} value={element.DocumentRevisionUSID}>
                                                        {`${element.DocumentRevision.DocumentID} Rev ${element.DocumentRevision.DisplayRevision}`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        )}
                                    </>
                                ) : null}
                            </div>
                            <div key="1" style={{display: "flex", flexDirection: "row", margin: "10px 20px 20px 0"}}>
                                {assemblyDocumentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                                    <TextField
                                        select
                                        key="AssemblyDocumentType"
                                        margin="dense"
                                        fullWidth={true}
                                        id="AssemblyDocumentType"
                                        label="Assembly Document Type *"
                                        onChange={(event) => {
                                            assemblyDocumentTypeChangedHandler(event);

                                            assemblyDocumentTypeFormEnterpriseComponent.newQuery();
                                            assemblyDocumentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                            assemblyDocumentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                            assemblyDocumentTypeFormEnterpriseComponent.executeQuery(1, 50);
                                        }}
                                        value={controls["AssemblyDocumentTypeUSID"].value}
                                        variant="outlined"
                                        slotProps={{
                                            input: {},
                                            inputLabel: {shrink: true}
                                        }}>
                                        {assemblyDocumentTypeBuffer.map((element: any) => (
                                            <MenuItem key={element.USID} value={element.get("USID")}>
                                                {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            </div>
                            <div key="2" style={{display: "flex", flexDirection: "row", margin: "10px 20px 20px 0"}}>
                                {controls["AssemblyDocumentTypeUSID"].value !== "" ? (
                                    <>
                                        {assemblyDocumentTypeFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                                            <TextField
                                                select
                                                key="Form"
                                                margin="dense"
                                                fullWidth={true}
                                                id="AssemblyForm"
                                                label="Assembly Form *"
                                                onChange={(event) => {
                                                    assemblyFormChangedHandler(event)
                                                }}
                                                value={controls["AssemblyFormDocumentRevisionUSID"].value}
                                                variant="outlined"
                                                slotProps={{
                                                    input: {},
                                                    inputLabel: {shrink: true}
                                                }}>
                                                {assemblyFormBuffer[0].get("ListOfFormTemplate").FormTemplate.map((element: any) => (
                                                    <MenuItem key={element.DocumentRevisionUSID} value={element.DocumentRevisionUSID}>
                                                        {`${element.DocumentRevision.DocumentID} Rev ${element.DocumentRevision.DisplayRevision}`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        )}
                                    </>
                                ) : null}
                            </div>
                            <div key="3" style={{display: "flex", flexDirection: "row", margin: "10px 20px 20px 0"}}>
                                {arDocumentTypeFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                                    <TextField
                                        select
                                        key="ARDocumentTypeUSID"
                                        margin="dense"
                                        fullWidth={true}
                                        id="ARDocumentTypeUSID"
                                        label="Approval Request Document Type *"
                                        onChange={(event) => {
                                            arDocumentTypeChangedHandler(event);

                                            arDocumentTypeFormEnterpriseComponent.newQuery();
                                            arDocumentTypeFormEnterpriseComponent.setAttributeValue("USID", event.target.value);
                                            arDocumentTypeFormEnterpriseComponent.setIDOCResponse("v1.DocumentType-002");
                                            arDocumentTypeFormEnterpriseComponent.executeQuery(1, 50);
                                        }}
                                        value={controls["ARDocumentTypeUSID"].value}
                                        variant="outlined"
                                        slotProps={{
                                            input: {},
                                            inputLabel: {shrink: true}
                                        }}>
                                        {arDocumentTypeBuffer.map((element: any) => (
                                            <MenuItem key={element.USID} value={element.get("USID")}>
                                                {`${element.get("DocumentTypeName")} (${element.get("DocumentTypeAcronym")})`}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                )}
                            </div>
                            <div key="4" style={{display: "flex", flexDirection: "row", margin: "10px 20px 20px 0"}}>
                                {controls["ARDocumentTypeUSID"].value !== "" ? (
                                    <>
                                        {arDocumentTypeFormFetchBackgroundOperation ? <img width="35" height="35" src={spinner} alt="spinner" /> : (
                                            <TextField
                                                select
                                                key="ARForm"
                                                margin="dense"
                                                fullWidth={true}
                                                id="ARForm"
                                                label="Approval Request Form *"
                                                onChange={(event) => {
                                                    arFormChangedHandler(event)
                                                }}
                                                value={controls["ARFormDocumentRevisionUSID"].value}
                                                variant="outlined"
                                                slotProps={{
                                                    input: {},
                                                    inputLabel: {shrink: true}
                                                }}>
                                                {arFormBuffer[0].get("ListOfFormTemplate").FormTemplate.map((element: any) => (
                                                    <MenuItem key={element.DocumentRevisionUSID} value={element.DocumentRevisionUSID}>
                                                        {`${element.DocumentRevision.DocumentID} Rev ${element.DocumentRevision.DisplayRevision}`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        )}
                                    </>
                                ) : null}
                            </div>
                        </div>
                    </DialogContent>
                    {buttonHandler}
                </Dialog>
            </>
        );
    }

    return (
        <>
            {updateView()}
        </>
    )
}
